<template>
    <div v-if="headerFilterPanels.length > 0">
        <CategorySearchHeaderFiltersSkeleton v-if="!pageStore.algoliaReady" :filter-panels="headerFilterPanels" />
        <div
            v-else
            class="mb-1 space-y-3 lg:mb-0 lg:flex lg:items-center lg:gap-2 lg:space-y-0 varify-inline-filters:lg:mb-1 varify-inline-filters:lg:block varify-inline-filters:lg:space-y-3"
        >
            <div
                v-for="filter in headerFilterPanels"
                :key="filter.filter_identifier"
                v-show="isAvailable(filter.filter_identifier)"
                class="space-y-2 lg:min-w-0"
            >
                <CategorySearchFilterPanelRadio
                    v-if="filter.filter_type === CategoryFilterTypeEnum.RADIO"
                    :attribute="filter.filter_identifier"
                    :limit="resolveHeaderLimit(filter)"
                    :show-more="false"
                    :show-counts="filter.is_showing_counts"
                    :is-persisted="filter.is_persisted"
                    :is-header="true"
                    :on-filter-applied="onFilterApplied"
                    :on-availability-change="hasOptions => setAvailability(filter.filter_identifier, hasOptions)"
                />

                <CategorySearchFilterPanelList
                    v-else
                    :attribute="filter.filter_identifier"
                    :limit="resolveHeaderLimit(filter)"
                    :show-more="false"
                    :filter-type="filter.filter_type"
                    :show-counts="filter.is_showing_counts"
                    :single-select-toggle="filter.is_single_select"
                    :is-persisted="filter.is_persisted"
                    :transform-items="
                        filter.filter_identifier === collectionFilterAttribute
                            ? productStore.transformCombinedItems
                            : productStore.transformFilterItems
                    "
                    :is-header="true"
                    :on-filter-applied="onFilterApplied"
                    :on-availability-change="hasOptions => setAvailability(filter.filter_identifier, hasOptions)"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import CategorySearchFilterPanelList from '@/pages/category/partials/category-search-filter-panel/CategorySearchFilterPanelList.vue';
import CategorySearchFilterPanelRadio from '@/pages/category/partials/category-search-filter-panel/CategorySearchFilterPanelRadio.vue';
import CategorySearchHeaderFiltersSkeleton from '@/pages/category/partials/CategorySearchHeaderFiltersSkeleton.vue';
import { categoryPageStore } from '@/stores/category/CategoryPageStore';
import { categoryProductStore } from '@/stores/category/CategoryProductStore';
import { type CategoryFilterObject, CategoryFilterTypeEnum } from '@/types/generated';
import { ref } from 'vue';

const props = defineProps<{
    headerFilterPanels: CategoryFilterObject[];
    collectionFilterAttribute: string;
    onFilterApplied: () => void;
}>();

const pageStore = categoryPageStore();
const productStore = categoryProductStore();
const filterAvailability = ref<Record<string, boolean>>({});

const resolveHeaderLimit = (filter: CategoryFilterObject): number => filter.number_of_values_in_header ?? 100;
const isAvailable = (attribute: string): boolean => filterAvailability.value[attribute] ?? true;
const setAvailability = (attribute: string, hasOptions: boolean): void => {
    const current = filterAvailability.value[attribute];
    if (current === hasOptions) {
        return;
    }

    filterAvailability.value[attribute] = hasOptions;
};
</script>
